import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../../Translations';
import { PublicNameProgramFamilyShareUrl } from '../../../../../../../../Types';
import InviteParticipantStore from '../../../../../InviteParticipantModal/Store';
import InviteIcon from './InviteIcon';

export interface Props {
  programFamilyShareUrl: PublicNameProgramFamilyShareUrl;
  inviteParticipantStore: InviteParticipantStore;
}

const openInviteParticipantModal = (
  inviteParticipantStore: InviteParticipantStore,
  programFamilyShareUrl: PublicNameProgramFamilyShareUrl,
) => {
  inviteParticipantStore.getLicenseInformation(programFamilyShareUrl);
  inviteParticipantStore.modalStore.open();
};

function InviteButton({ inviteParticipantStore, programFamilyShareUrl }: Props) {
  return (
    <div className="bg-white border-1 mr-4 flex items-center rounded border-teal-600 text-teal-600 py-4 px-3 text-xs">
      <span
        onClick={() => openInviteParticipantModal(inviteParticipantStore, programFamilyShareUrl)}
        className="cursor-pointer flex items-center justify-center w-26 h-6"
      >
        <InviteIcon />
        <span className="ml-2">
          <T kind="Invite Participants" />
        </span>
      </span>
    </div>
  );
}

export default observer(InviteButton);
